import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceStatusLabelModule } from '@shared/component/device-status-label/device-status-label.module';
import { ErrorBoxModule } from '@shared/component/error-box/error-box.module';
import { ChangePasswordModalComponent } from '@shared/component/my-account/change-password-modal/change-password-modal.component';
import { AddDeviceDialogComponent } from '@shared/component/my-account/devices/add-device-dialog/add-device-dialog.component';
import { MyAccountDevicesListComponent } from '@shared/component/my-account/devices/my-account-devices-list.component';
import { MyAccountComponent } from '@shared/component/my-account/my-account.component';
import { CountryNamePipe } from '@shared/pipes/country-name.pipe';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { SfCountrySelectorModule } from '@shared/sf-form-controls/sf-country-selector/sf-country-selector.module';
import { SfInputModule } from '@shared/sf-form-controls/sf-input/sf-input.module';
import { SharedModule } from '@shared/shared.module';
import { UserLicenseInfoLimitsModule } from '../user-license-info-limits/user-license-info-limits.module';
import { UserDataModalComponent } from './user-data-modal/user-data-modal.component';
import { PlanIconPipe } from './utils/plan-icon.pipe';

@NgModule({
	declarations: [
		MyAccountComponent,
		ChangePasswordModalComponent,
		PlanIconPipe,
		UserDataModalComponent,
		MyAccountDevicesListComponent,
		AddDeviceDialogComponent,
	],
	imports: [
		CommonModule,
		MatIconModule,
		TranslateModule,
		SfInputModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatButtonModule,
		ErrorBoxModule,
		MatRadioModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatInputModule,
		MatFormFieldModule,
		UserLicenseInfoLimitsModule,
		SharedModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		SfCountrySelectorModule,
		CountryNamePipe,
		LocalizedDatePipe,
		DeviceStatusLabelModule,
		ClipboardModule,
	],
	exports: [MyAccountComponent, ChangePasswordModalComponent],
})
export class MyAccountModule {}
